export default {
  ANNUAL: "SCALE_ANNUAL_SUBSCRIPTION",
  MONTHLY: "SCALE_ANNUAL_SUBSCRIPTION_MONTHLY",
};